import {
  COVER_SHARE_BUTTONS_NOT_IN_VIEW,
  COVER_SHARE_BUTTONS_IN_VIEW,
  TITLE_ABOVE_OR_BELOW_VIEWPORT,
  SCROLL_DIRECTION_CHANGED,
} from './visibility.actions'

const INITIAL_STATE = {
  coverShareButtonsInView: true,
  titleIsAboveViewport: false,
  isScrollUp: false,
}

export function visibilityReducers(state = INITIAL_STATE, action) {
  switch (action.type) {
    case COVER_SHARE_BUTTONS_NOT_IN_VIEW:
      return { ...state, coverShareButtonsInView: false }
    case COVER_SHARE_BUTTONS_IN_VIEW:
      return { ...state, coverShareButtonsInView: true }
    case TITLE_ABOVE_OR_BELOW_VIEWPORT:
      return { ...state, titleIsAboveViewport: action.payload.isAbove }
    case SCROLL_DIRECTION_CHANGED:
      return { ...state, isScrollUp: action.payload.isScrollUp }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/visibility/visibility.reducers.js